import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SwapRouter from './components/SwapRouter';
import OrderStatus from './components/OrderStatus';
import SplitNowOrderStatus from './components/SplitNowOrderStatus';
import AdminDashboard from './components/AdminDashboard';
import ApiDocs from './components/ApiDocs';
import ExplorerPage from './components/ExplorerPage';
import { useTheme } from './hooks/useTheme';
import { LanguageProvider } from './i18n/LanguageContext';
import './styles/App.css';

// Component to update title based on route
function PageTitle() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    let title = 'IceSwap';
    
    if (path === '/') title = 'IceSwap - Anonymous Crypto Exchange';
    else if (path === '/admin') title = 'Admin Dashboard | IceSwap';
    else if (path === '/docs') title = 'API Documentation | IceSwap';
    else if (path.startsWith('/order/')) title = 'Order Status | IceSwap';
    else if (path.startsWith('/cex/order/')) title = 'Private Order | IceSwap';
    else if (path.startsWith('/explorer')) title = "Order Explorer | IceSwap";
    
    document.title = title;
  }, [location]);

  return null;
}

function App() {
  const [theme, toggleTheme] = useTheme();

  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <PageTitle />
          <div className="app">
            <Routes>
              <Route path="/" element={<SwapRouter theme={theme} toggleTheme={toggleTheme} />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/docs" element={<ApiDocs />} />
              <Route path="/explorer" element={<ExplorerPage />} />
              <Route path="/order/:orderId" element={<OrderStatus />} />
              <Route path="/cex/order/:orderId" element={<SplitNowOrderStatus />} />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;